module.exports = __webpack_public_path__ + "img/national.e5608e62.png";